import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Box, Flex } from '@chakra-ui/react';
import { Logo, GlobalHeaderv2, SgiCanadaLogo } from '@sgi/gravity';
import { useEventBusListener } from '../../../../../shell/messaging/useEventBusListener';
import { loginRequestB2C, logoutRequestB2C } from '../../../../';
import { GlobalEvents } from '../../../../types/events/globalEvents';
import AppUserMenu from './AppUserMenu';
import './Header.css';
import { useNavigate } from 'react-router-dom';
import { IssuerBanner } from '../IssuerBanner/IssuerBanner';
import { useUser } from '../../../../../shell/session';
import { AppSideBar } from '../AppSideBar';
import { useState } from 'react';
export function AppHeader() {
    const { instance } = useMsal();
    const msal = useMsal();
    const customerName = msal.accounts[0]?.idTokenClaims?.name ?? '';
    const isAuthenticated = useIsAuthenticated();
    const navigate = useNavigate();
    const { isSGICanadaUser } = useUser();
    const [shoppingCartShortcut, setShoppingCartShortcutData] = useState(null);
    const onBellClick = () => {
        navigate('/profile/notifications');
    };
    useEventBusListener(GlobalEvents.updateShoppingCartShortcutEvent, (data) => {
        setShoppingCartShortcutData(data);
    }, { once: false });
    const onCartClick = () => {
        navigate('/shopping-cart');
    };
    return (_jsxs(_Fragment, { children: [!isSGICanadaUser && _jsx(IssuerBanner, {}), _jsx(Flex, { w: "100%", flexGrow: 1, background: 'var(--sgi-colors-white)', borderBottom: '1px solid var(--sgi-colors-gray-100)', backdropFilter: 'blur(2px)', height: '64px', zIndex: 2, children: _jsx(Box, { w: "100%", children: _jsx(GlobalHeaderv2, { brand: "", logo: _jsxs(_Fragment, { children: [_jsx(Logo, { width: "150px" }), isSGICanadaUser && _jsx(SgiCanadaLogo, { width: "100px" })] }), isSignedIn: isAuthenticated, userName: customerName, onSignInClick: () => instance.loginRedirect({
                            ...loginRequestB2C,
                            redirectStartPage: '/',
                        }), hideBellButton: isSGICanadaUser, hideCartButton: isSGICanadaUser, onSignOutClick: () => instance.logoutRedirect(logoutRequestB2C), userMenuBody: _jsx(AppUserMenu, {}), onBellButtonClick: onBellClick, cartNotificationCount: shoppingCartShortcut?.numberOfItems, onCartButtonClick: onCartClick, mobileMenuBody: _jsx(AppSideBar, { showOnMobile: true }) }) }) })] }));
}
